import { useNavigate } from 'react-router-dom';
import { LoadingState } from '@localagent/ui/components/shogun-spinner';
import { usePositionOpenQuestions } from '../../hooks/usePositionOpenQuestions';
import { QUESTIONS_TAB_ID } from '../chat/chat-tabs';

export interface PositionOpenQuestionsProps {
  positionId: string;
}

export function PositionOpenQuestions({ positionId }: PositionOpenQuestionsProps) {
  const navigate = useNavigate();
  const { questions, error } = usePositionOpenQuestions(positionId);

  return (
    <div data-testid="position-open-questions" className="space-y-2 pt-4">
      <span className="text-body text-muted-foreground">Open questions</span>

      {error && (
        <div className="text-body text-destructive">
          Failed to load open questions: {error.message}
        </div>
      )}

      {!error && questions === null && <LoadingState label="Loading open questions..." />}

      {questions !== null && questions.length === 0 && (
        <div className="text-body text-muted-foreground italic">No open questions</div>
      )}

      {questions !== null && questions.length > 0 && (
        <ul className="flex flex-col">
          {questions.map((q) => (
            <li key={q.question_id}>
              <button
                type="button"
                data-testid={`position-open-question-${q.question_id}`}
                data-session-id={q.session_id}
                onClick={() => void navigate(`/chat/${q.session_id}?tab=${QUESTIONS_TAB_ID}`)}
                className="flex w-full flex-col items-start gap-0.5 rounded-md px-2 py-1.5 text-left hover:bg-accent"
              >
                <span className="w-full truncate text-label font-medium text-foreground">{q.question}</span>
                <span className="w-full truncate text-caption text-muted-foreground">
                  {q.asker_name} · {q.session_title}
                </span>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
